import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ValidationConstants, ValidationConstants as validationConstants } from '../../../constants/validation-constants';


@Injectable()
export class QuestionnaireFormUtil {

    constructor(private formBuilder: FormBuilder) { }

    initializeForm() {
        return this.formBuilder.group({
            id: new FormControl(), // Used only for VIEW 
            orgid: new FormControl(), // Used only for VIEW 
            name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            evaluationscale: new FormControl(''),
            category: new FormControl(''),
            duration: new FormControl(''),
            durationtype: new FormControl(''),
            subcategory: new FormControl(''),
            level: new FormControl(''),
            createdby: new FormControl(''),
            createdon: new FormControl(''),
            modifiedby: new FormControl(''),
            //questions 
            questions: this.formBuilder.array([]), // FormArray
            tags: this.formBuilder.array([]), // FormArray
        });
    }

    initializeQuestionsForm() {
        return this.formBuilder.group({
            questions: this.formBuilder.array([]), // FormArray
        });
    }


    updateDynamicValidation(candidateCreateForm: FormGroup) {
        // name
        candidateCreateForm.get('name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
        //update value and validity 
        candidateCreateForm.updateValueAndValidity();
        return candidateCreateForm;
    }



    //Questions Form Array 
    addNewQuestionFormArrayField() {
        return this.formBuilder.group({
            id: new FormControl(),
            sortorder: new FormControl(),
            questiontype: new FormControl(''),
            question: new FormControl(''),
            tags: this.formBuilder.array([]),
            weight: new FormControl(''),
            negativeWeight: new FormControl(''),
            options: this.formBuilder.array([]),
            answer: this.formBuilder.array([]),
            correctanswer: this.formBuilder.array([]),
            // Likert scale type question length (number of items in scale)
            likertlength: new FormControl(),
            // Likert scale type question Interval between two items
            stepcount: new FormControl(1),
            // Likert scale type question lable available at the left side
            leftlikertlabel: new FormControl(''),
            // Likert scale type question lable available at the left side
            rightlikertlabel: new FormControl(''),
            // Likert scale type question width of each item in the scale
            likertwidth: new FormControl()
        });
    }

    addNewQuestionFieldBasedOnData(data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            questiontype: new FormControl(data.questiontype, [Validators.required]),
            question: new FormControl(data.question, [Validators.required, Validators.pattern(ValidationConstants.REGEX_ALPHANUMERIC_TYPE5)]),
            tags: this.formBuilder.array([]),
            weight: new FormControl(data.weight),
            negativeWeight: new FormControl(data.negativeWeight),
            options: this.formBuilder.array([]),
            sortorder: new FormControl(data.sortorder),
            answer: this.formBuilder.array([]),
            correctanswer: this.formBuilder.array([]),
            status: new FormControl(data.status),
            // Likert scale type question length (number of items in scale)
            likertlength: new FormControl(data.likertlength, [Validators.pattern(ValidationConstants.REGEX_INTEGER_TYPE3), Validators.max(10)]),
            // Likert scale type question Interval between two items
            stepcount: new FormControl(data.stepcount, [Validators.pattern(ValidationConstants.REGEX_INTEGER_TYPE3)]),
            // Likert scale type question lable available at the left side
            leftlikertlabel: new FormControl(data.leftlikertlabel, [Validators.pattern(ValidationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
            // Likert scale type question lable available at the right side
            rightlikertlabel: new FormControl(data.rightlikertlabel, [Validators.pattern(ValidationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
            // Likert scale type question width of each item in the scale
            likertwidth: new FormControl(data.likertwidth, [Validators.pattern(ValidationConstants.REGEX_INTEGER_TYPE3)])
        });
    }

    addOptionsField() {
        return this.formBuilder.group({
            optionvalue: new FormControl(),
            readonly: new FormControl(false),
        });
    }
    addOptionsFieldBasedOnData(data) {
        return this.formBuilder.group({
            optionvalue: new FormControl(data.optionvalue),
            readonly: new FormControl(data.readonly),
        });
    }
    addAnswerField() {
        return this.formBuilder.group({
            value: new FormControl(),
        });
    }
    addAnswerFieldBasedOnData(data) {
        return this.formBuilder.group({
            value: new FormControl(data.value),
        });
    }
    addTags() {
        return new FormControl('');
    }
    addTagswithData(data) {
        return new FormControl(data);
    }
}